import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  margin-bottom: 4px;
  .search {
    display: flex;
    .first {
      width: 300px;
      height: 120px;
      display: flex;
      align-items: center;
      padding-left: 32px;
      /* justify-content: center; */
      border-radius: 14px;
      background-color: #fff;
      box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
      .appId {
        width: 230px;
      }
    }
    .second {
      flex-grow: 1;
      margin-left: 4px;
      border-radius: 14px;
      padding: 0 32px;
      background-color: #fff;
      box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      .button-group {
        height: 100%;
        margin-left: 160px;
        display: flex;
        .MuiFab-root {
          color: #fff;
          width: 122px;
          height: 40px;
        }
        align-items: center;
        .reset {
          margin-right: 24px;
        }
        .search {
          margin-right: 0;
        }
      }
      > .left {
        flex-grow: 1;
        display: flex;
        gap: 48px;
        > div {
          flex: 1;
        }
      }
    }
  }
  .search-wrapper {
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
    padding: 0 32px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    height: 120px;

    .left {
      flex-grow: 1;
      display: flex;
      align-items: center;
      .appId {
        width: 230px;
      }
    }

    .button-group {
      height: 100%;
      margin-left: 160px;
      display: flex;
      .MuiFab-root {
        color: #fff;
        width: 140px;
        height: 40px;
        border-radius: 32px;
        .MuiSvgIcon-root {
          margin-right: 8px;
        }
      }
      align-items: center;
      .reset {
        margin-right: 24px;
      }
      .search {
        margin-right: 0;
      }
    }
    .first-line {
      width: 100%;
      display: flex;
      height: 100%;
      align-items: center;
      gap: 48px;
      flex: 1;
      > div {
        flex: 1;
      }
    }
  }
`;
export default SearchGroupStyled;
